<template>
    <v-container fluid>
        <DynamicToolbar
            title="Zone Durations"
            :loading="loading"
            color="#21449B"
            icon="mdi-map-clock"
            theme="dark"
        ></DynamicToolbar>
        <v-card outlined>
            <!-- <v-card-title>
                <span class="headline">Filters</span>
            </v-card-title> -->
            <v-card-text>
                <v-row>
                    <v-col cols="6" md="6">
                        <v-card outlined>
                            <!-- <v-card-title>
                                <span class="subtitle-1">By Zone</span>
                            </v-card-title> -->
                            <v-card-text>
                                <!-- <v-radio-group
                                    v-model="filters.byZone.type"
                                    row
                                >
                                    <v-radio
                                        label="All zones"
                                        value="all"
                                    ></v-radio>
                                    <v-radio
                                        label="Combination"
                                        value="combination"
                                    ></v-radio>
                                </v-radio-group> -->
                                <v-autocomplete
                                    v-if="filters.byZone.type == 'combination'"
                                    v-model="filters.byZone.combination.origin"
                                    :items="geotabZones"
                                    item-text="name"
                                    item-value="id"
                                    label="Origin"
                                    prepend-icon="mdi-map-marker"
                                    dense
                                    outlined
                                    class="pt-3 pl-3 pr-3"
                                ></v-autocomplete>
                                <v-autocomplete
                                    v-if="filters.byZone.type == 'combination'"
                                    v-model="filters.byZone.combination.destination"
                                    :items="geotabZones"
                                    item-text="name"
                                    item-value="id"
                                    label="Destination"
                                    prepend-icon="mdi-map-marker"
                                    dense
                                    outlined
                                    class="pl-3 pr-3"
                                ></v-autocomplete>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6">
                        <v-card outlined>
                            <v-card-text v-if="combination.loading">
                                <row>
                                    <v-col cols="12" md="12">
                                        <div class="spinner"></div>
                                    </v-col>
                                </row>
                            </v-card-text>
                            <v-card-text v-else>
                                <row>
                                    <v-col cols="12" md="12">
                                        <v-text-field
                                            v-model="combination.zoneEvent"
                                            label="Zone event"
                                            prepend-icon="mdi-earth"
                                            readonly
                                            hide-details
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <v-text-field
                                            v-model="combination.totalAverageTime"
                                            label="Total average time"
                                            readonly
                                            hide-details
                                            prepend-icon="mdi-timer"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                </row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <!-- <v-col cols="6" md="6">
                        <v-card outlined>
                            <v-card-title>
                                <span class="subtitle-1">By Period</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            sm="4"
                                            md="4"
                                        >
                                            <v-checkbox
                                                v-model="ex4"
                                                label="Evening"
                                                color="red"
                                                value="red"
                                                hide-details
                                            ></v-checkbox>
                                            <v-checkbox
                                            v-model="ex4"
                                            label="red darken-3"
                                            color="red darken-3"
                                            value="red darken-3"
                                            hide-details
                                            ></v-checkbox>
                                        </v-col>
                                    <v-col
                                        cols="12"
                                        sm="4"
                                        md="4"
                                    >
                                        <v-checkbox
                                        v-model="ex4"
                                        label="indigo"
                                        color="indigo"
                                        value="indigo"
                                        hide-details
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="ex4"
                                        label="indigo darken-3"
                                        color="indigo darken-3"
                                        value="indigo darken-3"
                                        hide-details
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="4"
                                        md="4"
                                    >
                                        <v-checkbox
                                        v-model="ex4"
                                        label="orange"
                                        color="orange"
                                        value="orange"
                                        hide-details
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="ex4"
                                        label="orange darken-3"
                                        color="orange darken-3"
                                        value="orange darken-3"
                                        hide-details
                                        ></v-checkbox>
                                    </v-col>
                                    </v-row>

                                    <v-row class="mt-12">
                                    <v-col
                                        cols="12"
                                        sm="4"
                                        md="4"
                                    >
                                        <v-checkbox
                                        v-model="ex4"
                                        label="primary"
                                        color="primary"
                                        value="primary"
                                        hide-details
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="ex4"
                                        label="secondary"
                                        color="secondary"
                                        value="secondary"
                                        hide-details
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="4"
                                        md="4"
                                    >
                                        <v-checkbox
                                        v-model="ex4"
                                        label="success"
                                        color="success"
                                        value="success"
                                        hide-details
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="ex4"
                                        label="info"
                                        color="info"
                                        value="info"
                                        hide-details
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="4"
                                        md="4"
                                    >
                                        <v-checkbox
                                        v-model="ex4"
                                        label="warning"
                                        color="warning"
                                        value="warning"
                                        hide-details
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="ex4"
                                        label="error"
                                        color="error"
                                        value="error"
                                        hide-details
                                        ></v-checkbox>
                                    </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-col> -->
                </v-row>
                <!-- <v-row>
                    <v-btn
                        color="#21449B"
                        depressed
                        dark
                        @click="getReport()"
                        outlined
                        style="margin: 10px;"
                    >
                        <v-icon left>mdi-table-multiple</v-icon>
                        Get Report
                    </v-btn>
                </v-row> -->
                
                <!-- <v-card outlined style="margin: 25px 0 15px;" v-if="combination.show">
                    <v-card-title class="text-h5 mb-2" style="padding-top: 25px;">
                        Datapoints
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="combination.searchBy"
                            append-icon="mdi-magnify"
                            label="Search here"
                            hide-details
                            style="padding-top: 0;margin-top: 0;"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            depressed
                            small
                            dark
                            @click="downloadReport()"
                            outlined
                            style="margin-right: 35px;"
                        >
                            <v-icon left>mdi-file-excel</v-icon>
                            Download Report
                        </v-btn>
                    </v-card-title>
                    <v-data-table
                        :headers="combination.headers"
                        :items="combination.items"
                        class="elevation-1"
                        dense
                        :search="combination.searchBy"
                    ></v-data-table>
                </v-card> -->
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';


export default {
    directives: { mask },
    props: [],
    components: {
        DynamicToolbar,
    },
    data: function () {
        return {
            loading: true,

            filters: {
                byZone: {
                    type: 'combination',
                    combination: {
                        origin: null,
                        destination: null,
                    }
                },
                // byPeriod: {
                //     byDay: {
                //         type: "",
                //     },
                //     byIntervals: {
                //         type: "",
                //     }
                // }
            },

            combination: {
                show: false,
                searchBy: '',
                items: [],
                headers: [
                    { text: 'Period', value: 'period_type' },
                    { text: 'Time interval', value: 'period_value' },
                    { text: 'Average time', value: 'average_time' },
                ],
                totalAverageTime: null,
                zoneEvent: null,
                loading: false,
            },

            startDate: '',
            endDate: '',

            geotabZones: [],
        }
    },
    mounted() {
        this.getGeotabZones();
    },
    methods: {
        getGeotabZones() {
            axios
                .get('geotab/zones')
                .then(response => {
                    this.geotabZones = response.data;
                    console.log('Geotab zones ', this.geotabZones);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getCombination() {
            console.log("Get combination", this.filters.byZone.combination);
            // let str = this.$store;
            // str.state.isLoading = true;
            let combination = this.filters.byZone.combination;
            this.combination.loading = true;
            axios
                .post(
                    'v2/dispatch/travel-times/combinations', combination
                )
                .then(response => {
                    console.log('Response combination: ', response.data);
                    let data = response.data;

                    this.combination.items = data.datapoints;
                    this.combination.zoneEvent = data.zone_event;
                    this.combination.totalAverageTime = data.total_average_time;
                    this.combination.show = true;

                    console.log('Combination: ', this.combination);
                   
                    this.combination.loading = false;
                    // str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.combination.loading = false;
                    // str.state.isLoading = false;
                });
        },
        downloadReport() {
            let str = this.$store;
            str.state.isLoading = true;
            let params = {
                ReportAlias: "ZoneDurations",
                Headers: this.combination.headersExcel,
                Data: this.combination.items,
                Filename: "ZoneDurations.xlsx"
            }
            axios
                .post('zone-durations/download', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    },
                    responseType: 'blob',
                })
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    let filename = "ZoneDurations.xlsx";
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Zone Durations';
            }
        },
        'filters.byZone.combination.origin': {
            handler(newVal, oldVal) {
                console.log('newVal ', newVal);
                console.log('oldVal ', oldVal);

                let combination = this.filters.byZone.combination;
                if (combination.destination) {
                    this.getCombination();
                }
            }
        },
        'filters.byZone.combination.destination': {
            handler(newVal, oldVal) {
                console.log('newVal ', newVal);
                console.log('oldVal ', oldVal);

                let combination = this.filters.byZone.combination;
                if (combination.origin) {
                    this.getCombination();
                }
            }
        }
    }
};
</script>

<style>
    .spinner {
        width: 40px;
        height: 40px;
        background-color: #21449b;

        margin: 38px auto;
        -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
        animation: sk-rotateplane 1.2s infinite ease-in-out;
    }

    @-webkit-keyframes sk-rotateplane {
        0% { -webkit-transform: perspective(120px) }
        50% { -webkit-transform: perspective(120px) rotateY(180deg) }
        100% { -webkit-transform: perspective(120px) rotateY(180deg)  rotateX(180deg) }
    }

    @keyframes sk-rotateplane {
        0% { 
            transform: perspective(120px) rotateX(0deg) rotateY(0deg);
            -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg) 
        } 50% { 
            transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
            -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg) 
        } 100% { 
            transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
            -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
        }
    }
</style>